import { deleteLocationProfile, fetchLocationProfiles, upsertLocationProfile } from '@/api/location-profile.api';
import type { ILocationProfile } from '@condo/domain';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';

export const useLocationProfiles = (params: { estateId?: number }) => {
    const queryClient = useQueryClient();
    const query = useQuery(['location-profiles'], async () => fetchLocationProfiles({ estateId: params?.estateId }), {
        initialData: [],
    });
    const { mutateAsync: upsertMutation } = useMutation(async (locationProfile: ILocationProfile) => upsertLocationProfile(locationProfile), {
        onSuccess: () => {
            queryClient.invalidateQueries(['location-profiles']);
        },
    });
    const { mutateAsync: deleteMutation } = useMutation(async (locationProfileId: number) => deleteLocationProfile(locationProfileId), {
        onSuccess: () => {
            queryClient.invalidateQueries(['location-profiles']);
        },
    });
    return { ...query, upsertMutation, deleteMutation };
};
